// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__TqylC","rootSuccess":"CompleteLink_rootSuccess__nxBU1","rootFailure":"CompleteLink_rootFailure__INSA3","isDisabled":"CompleteLink_isDisabled__24G_N"};